import { UserGroupIcon, Squares2X2Icon, VideoCameraIcon, FilmIcon, GlobeAltIcon, CreditCardIcon, ClockIcon, UserCircleIcon } from '@heroicons/react/24/outline'
import { getImageSrc, } from '../../../../services/util'
import { useNavigate } from "react-router-dom";
import { useGetDashboardReport } from 'hooks/dashboard';

export const Dashboard = () => {
    const navigate = useNavigate();
    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    const { data: dashboardData } = useGetDashboardReport({
        month: currentMonth,
        year: currentYear,
    })

    const comprehensiveDashboardData = dashboardData?.data?.results;
    const userStats = comprehensiveDashboardData?.userStats;
    const contentStats = comprehensiveDashboardData?.contentStats;
    const topEpisodes = comprehensiveDashboardData?.topEpisodes ?? [];

    const totalCollections = contentStats?.totalCollections;
    const totalCategories = contentStats?.totalCategories;
    const totalShows = contentStats?.totalShows;
    const totalEpisodes = contentStats?.totalEpisodes;

    const formatDuration = (seconds: number) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, "0")}`;
    };

    /*Paid users count*/
    const paidUsers = userStats?.paidUsers ?? 0;
    const ottUsers = userStats?.totalUsers ?? 0;
    const trialUsers = userStats?.trialUsers ?? 0;
    const freeUsers = userStats?.freeUsers ?? 0;

    const statCards = [

        // OTT Users
        (
            <div onClick={() => navigate("/ott-user-management/ott-users")} className="group relative rounded-xl bg-slate-100 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 p-2 transition hover:shadow-md hover:bg-slate-200 dark:hover:bg-slate-800 cursor-pointer">
                <div className="flex items-center justify-between mb-1">
                    <p className="text-[11px] font-medium text-gray-600 dark:text-gray-400 truncate pr-2">
                        OTT Users
                    </p>
                    <div className="p-1.5 rounded-md bg-indigo-100 dark:bg-indigo-500/10">
                        <UserGroupIcon className="w-4 h-4 text-indigo-600 dark:text-indigo-400" />
                    </div>
                </div>

                <p className="text-lg leading-5 font-semibold text-gray-900 dark:text-white truncate">
                    {ottUsers}
                </p>

                <p className="text-[10px] text-gray-500 dark:text-gray-400 mt-1 truncate">
                    All active users
                </p>
            </div>
        ),


        // Paid User
        (
            <div className="group rounded-xl bg-slate-100 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 p-2 transition hover:shadow-md hover:bg-slate-200 dark:hover:bg-slate-800">
                <div className="flex items-center justify-between mb-1">
                    <p className="text-[11px] font-medium text-gray-600 dark:text-gray-400 truncate pr-2">Paid Users</p>
                    <div className="p-1.5 rounded-md bg-emerald-100 dark:bg-emerald-500/10">
                        <CreditCardIcon className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />
                    </div>
                </div>

                <p className="text-lg leading-5 font-semibold text-gray-900 dark:text-white truncate">{paidUsers}</p>
                <p className="text-[10px] text-emerald-600 dark:text-emerald-400 mt-1 truncate">
                    Active subscriptions
                </p>
            </div>
        ),

        // Trial Users Card
        (
            <div className="group rounded-xl bg-slate-100 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 p-2 transition hover:shadow-md hover:bg-slate-200 dark:hover:bg-slate-800">
                <div className="flex items-center justify-between mb-1">
                    <p className="text-[11px] font-medium text-gray-600 dark:text-gray-400 truncate pr-2">Trial Users</p>
                    <div className="p-1.5 rounded-md bg-yellow-100 dark:bg-yellow-500/10">
                        <ClockIcon className="w-4 h-4 text-yellow-600 dark:text-yellow-400" />
                    </div>
                </div>

                <p className="text-lg leading-5 font-semibold text-gray-900 dark:text-white truncate">{trialUsers}</p>
                <p className="text-[10px] text-yellow-600 dark:text-yellow-400 mt-1 truncate">
                    In trial period
                </p>
            </div>
        ),

        // Free Users
        (
            <div className="group rounded-xl bg-slate-100 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 p-2 transition hover:shadow-md hover:bg-slate-200 dark:hover:bg-slate-800">
                <div className="flex items-center justify-between mb-1">
                    <p className="text-[11px] font-medium text-gray-600 dark:text-gray-400 truncate pr-2">Free Users</p>
                    <div className="p-1.5 rounded-md bg-gray-200 dark:bg-gray-500/10">
                        <UserCircleIcon className="w-4 h-4 text-gray-600 dark:text-gray-400" />
                    </div>
                </div>

                <p className="text-lg leading-5 font-semibold text-gray-900 dark:text-white truncate">{freeUsers}</p>
                <p className="text-[10px] text-gray-500 dark:text-gray-400 mt-1 truncate">
                    No subscription
                </p>
            </div>
        ),

        // Total Category
        (
            <div onClick={() => navigate("/category")} className="group rounded-xl bg-slate-100 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 p-2 transition hover:shadow-md hover:bg-slate-200 dark:hover:bg-slate-800 cursor-pointer">
                <div className="flex items-center justify-between mb-1">
                    <p className="text-[11px] font-medium text-gray-600 dark:text-gray-400 truncate pr-2">Total Category</p>
                    <div className="p-1.5 rounded-md bg-pink-100 dark:bg-pink-500/10">
                        <Squares2X2Icon className="w-4 h-4 text-pink-600 dark:text-pink-400" />
                    </div>
                </div>

                <p className="text-lg leading-5 font-semibold text-gray-900 dark:text-white truncate">
                    {totalCategories}
                </p>
                <p className="text-[10px] text-gray-500 dark:text-gray-400 mt-1 truncate">
                    Updated recently
                </p>
            </div>
        ),

        // Total Collection
        (
            <div onClick={() => navigate("/collections")} className="group rounded-xl bg-slate-100 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 p-2 transition hover:shadow-md hover:bg-slate-200 dark:hover:bg-slate-800 cursor-pointer">
                <div className="flex items-center justify-between mb-1">
                    <p className="text-[11px] font-medium text-gray-600 dark:text-gray-400 truncate pr-2">Total Collection</p>
                    <div className="p-1.5 rounded-md bg-indigo-100 dark:bg-indigo-500/10">
                        <FilmIcon className="w-4 h-4 text-indigo-600 dark:text-indigo-400" />
                    </div>
                </div>

                <p className="text-lg leading-5 font-semibold text-gray-900 dark:text-white truncate">
                    {totalCollections}
                </p>
                <p className="text-[10px] text-gray-500 dark:text-gray-400 mt-1 truncate">
                    Grouped content
                </p>
            </div>
        ),

        // Total Shows

        (
            <div onClick={() => navigate("/show")} className="group rounded-xl bg-slate-100 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 p-2 transition hover:shadow-md hover:bg-slate-200 dark:hover:bg-slate-800 cursor-pointer">
                <div className="flex items-center justify-between mb-1">
                    <p className="text-[11px] font-medium text-gray-600 dark:text-gray-400 truncate pr-2">Total Shows</p>
                    <div className="p-1.5 rounded-md bg-pink-100 dark:bg-pink-500/10">
                        <GlobeAltIcon className="w-4 h-4 text-pink-600 dark:text-pink-400" />
                    </div>
                </div>

                <p className="text-lg leading-5 font-semibold text-gray-900 dark:text-white truncate">
                    {totalShows}
                </p>
                <p className="text-[10px] text-gray-500 dark:text-gray-400 mt-1 truncate">
                    All shows
                </p>
            </div>
        ),

        // Total Episodes
        (
            <div onClick={() => navigate("/episodes")} className="group rounded-xl bg-slate-100 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 p-2 transition hover:shadow-md hover:bg-slate-200 dark:hover:bg-slate-800 cursor-pointer">
                <div className="flex items-center justify-between mb-1">
                    <p className="text-[11px] font-medium text-gray-600 dark:text-gray-400 truncate pr-2">Total Episodes</p>
                    <div className="p-1.5 rounded-md bg-purple-100 dark:bg-purple-500/10">
                        <VideoCameraIcon className="w-4 h-4 text-purple-600 dark:text-purple-400" />
                    </div>
                </div>

                <p className="text-lg leading-5 font-semibold text-gray-900 dark:text-white truncate">
                    {totalEpisodes}
                </p>
                <p className="text-[10px] text-gray-500 dark:text-gray-400 mt-1 truncate">
                    All episodes
                </p>
            </div>
        ),
    ];

    const userCards = [
        statCards[0], // OTT Users
        statCards[1], // Paid Users
        statCards[2], // Trial Users
        statCards[3], // Free Users
    ];

    const engagementCards = [
        statCards[7], // Episodes
        statCards[6], // Shows
        statCards[5], // Collections
        statCards[4], // Category
    ];

    return (
        <div className="h-[calc(100vh-64px)] overflow-hidden p-2">
            <div className="h-full w-full p-4 bg-white dark:bg-slate-800 rounded-lg border border-slate-300 dark:border-slate-500 shadow-md">
                <div className="h-full flex flex-col min-h-0">
                    <div className="w-full flex items-center mb-3">
                        <h5 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">Dashboard</h5>
                    </div>

                    <div className="flex flex-col gap-3 flex-1 min-h-0">
                        <section>
                            <h2 className="text-xs font-semibold text-gray-500 mb-2">USER METRICS</h2>
                            <div className="grid gap-3 grid-cols-2 md:grid-cols-4">
                                {userCards.map((card, index) => (
                                    <div key={index} className="h-[86px] [&>div]:h-full [&>div]:p-2">
                                        {card}
                                    </div>
                                ))}
                            </div>
                        </section>

                        <section>
                            <h2 className="text-xs font-semibold text-gray-500 mb-2">CONTENT METRICS</h2>
                            <div className="grid gap-3 grid-cols-2 md:grid-cols-4">
                                {engagementCards.map((card, index) => (
                                    <div key={index} className="h-[86px] [&>div]:h-full [&>div]:p-2">
                                        {card}
                                    </div>
                                ))}
                            </div>
                        </section>

                        <div className="grid gap-3 lg:grid-cols-2 flex-1 min-h-0">
                            <div className="rounded-2xl p-4 shadow-sm border border-gray-200 dark:border-slate-700 bg-slate-100 dark:bg-slate-900 min-h-0 overflow-auto">
                                <div className="flex justify-between items-center mb-3">
                                    <h3 className="font-semibold text-gray-900 dark:text-white text-[16px]">Top 10 Episode</h3>
                                    <span className="text-xs text-gray-500 dark:text-gray-400">Based on total views</span>
                                </div>

                                <div className="overflow-x-hidden">
                                    <table className="w-full text-sm table-fixed border-collapse">
                                        <thead className="text-left text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-slate-700">
                                            <tr>
                                                <th className="pb-3 text-left w-[7%]">#</th>
                                                <th className="pb-3 text-left w-[48%]">Video</th>
                                                <th className="pb-3 text-right w-[17%]">Views</th>
                                                <th className="pb-3 text-right w-[16%]">Creator</th>
                                                <th className="pb-3 text-right w-[12%]">Duration</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 dark:divide-slate-700">
                                            {topEpisodes.slice(0, 10).map((episode, i) => (
                                                <tr key={episode.id} className="hover:bg-gray-50 dark:hover:bg-slate-800/60 transition">
                                                    <td className="py-2.5 text-gray-600 dark:text-gray-400 whitespace-nowrap">{i + 1}</td>
                                                    <td className="py-2.5 pr-2">
                                                        <div className="flex items-center gap-2.5 min-w-0">
                                                            <img
                                                                src={getImageSrc(episode.thumbnail)}
                                                                alt={episode.name}
                                                                className="w-10 h-7 rounded object-cover bg-gray-200 dark:bg-slate-700"
                                                                onError={(e) => {
                                                                    e.currentTarget.src = "/fallback-thumbnail.png"; // optional fallback
                                                                }}
                                                            />
                                                            <span className="font-medium text-gray-900 dark:text-white truncate">{episode.name}</span>
                                                        </div>
                                                    </td>
                                                    <td className="py-2.5 text-right font-medium text-gray-900 dark:text-white whitespace-nowrap">{episode.views.toLocaleString("en-IN")}</td>
                                                    <td className="py-2.5 text-right text-gray-600 dark:text-gray-300 whitespace-nowrap">{episode.creator}</td>
                                                    <td className="py-2.5 text-right text-gray-500 dark:text-gray-400 whitespace-nowrap">{formatDuration(episode.duration)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="rounded-2xl p-4 shadow-sm bg-slate-100 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 min-h-0">
                                <div className="flex items-center justify-between mb-3">
                                    <h3 className="font-semibold text-gray-900 dark:text-white text-[16px]">CMS Activity</h3>
                                    <span className="text-xs px-3 py-1 rounded-full bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 text-gray-500">Live</span>
                                </div>

                                <div className="relative pl-6 space-y-4">
                                    <div className="absolute left-2 top-0 bottom-0 w-[2px] bg-gray-200 dark:bg-slate-700"></div>

                                    <div className="relative group">
                                        <div className="absolute -left-[6px] top-1 w-4 h-4 rounded-full bg-emerald-500 ring-4 ring-white dark:ring-slate-900"></div>
                                        <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-xl p-3.5 transition hover:shadow-md hover:-translate-y-[1px]">
                                            <p className="text-gray-800 dark:text-gray-200 font-medium">New user signed up</p>
                                            <span className="text-gray-400 text-xs">2 min ago</span>
                                        </div>
                                    </div>

                                    <div className="relative group">
                                        <div className="absolute -left-[6px] top-1 w-4 h-4 rounded-full bg-blue-500 ring-4 ring-white dark:ring-slate-900"></div>
                                        <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-xl p-3.5 transition hover:shadow-md hover:-translate-y-[1px]">
                                            <p className="text-gray-800 dark:text-gray-200 font-medium">Subscription upgraded</p>
                                            <span className="text-gray-400 text-xs">1 hour ago</span>
                                        </div>
                                    </div>

                                    <div className="relative group">
                                        <div className="absolute -left-[6px] top-1 w-4 h-4 rounded-full bg-violet-500 ring-4 ring-white dark:ring-slate-900"></div>
                                        <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-xl p-3.5 transition hover:shadow-md hover:-translate-y-[1px]">
                                            <p className="text-gray-800 dark:text-gray-200 font-medium">Server deployment completed</p>
                                            <span className="text-gray-400 text-xs">Yesterday</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}